import { now } from "@@/shared/date-time/date-time";
import { z } from "zod";
import { productFormFieldBaseZodObject } from "../product-form-field-base";
import type { ProductFormFieldId } from "../product-form-field-id";
import {
    productFormFieldIdFactory,
    productFormFieldIdZodSchema,
} from "../product-form-field-id";

const productFormFieldTextZodObject = productFormFieldBaseZodObject.merge(
    z.object({
        _id: productFormFieldIdZodSchema,
        type: z.literal("TEXT"),
        defaultValue: z.string().optional(),
        required: z.boolean(),
    }),
);

type ProductFormField_Text = z.infer<typeof productFormFieldTextZodObject>;

const factoryParamsZodObject = productFormFieldTextZodObject.omit({
    _id: true,
    _type: true,
    _createdAt: true,
    type: true,
});
type FactoryParams = z.infer<typeof factoryParamsZodObject>;

const productFormFieldTextFactory = (
    input: FactoryParams & { _id?: ProductFormFieldId },
): ProductFormField_Text => {
    return {
        ...input,
        _id: input._id ?? productFormFieldIdFactory(),
        _type: "PRODUCT_FIELD",
        _createdAt: now(),
        type: "TEXT",
    };
};

const isProductFormFieldText = (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    input: any,
): input is ProductFormField_Text => {
    return input?._type === "PRODUCT_FIELD" && input?.type === "TEXT";
};

export {
    isProductFormFieldText,
    productFormFieldTextFactory,
    factoryParamsZodObject as productFormFieldTextFactoryParamsZodObject,
    productFormFieldTextZodObject,
};
export type {
    ProductFormField_Text,
    FactoryParams as ProductFormField_TextFactoryParams,
};
